import { clsx } from 'clsx';
import { Button, Select } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import React, { Dispatch, SetStateAction } from 'react';

import { Crop } from '@types';
import cls from './DealerUniqueCropsField.module.css';


type Option = { value: number | string; label: string };
const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
  'Septiembre', 'Octubre', 'Noviembre', 'Diciembre', 'Todo el año',
];

export interface UniqueCropProps {
  idx: string;
  crop: string;
  ibm: string[];
  harvestMonth?: string[];
  states?: string[];
}

interface Props {
  crops: Crop[];
  states: Option[];
  setValue: Dispatch<SetStateAction<UniqueCropProps[]>>;
  value: UniqueCropProps[];
}

export const DealerUniqueCropsField = ({ states, crops, setValue, value }: Props) => {
  const hasEmptyCrops = value.some(({ crop }) => crop === '');

  const addCropsIbmHandler = () => {
    if (hasEmptyCrops) return;
    setValue(prev => [...prev, { crop: '', ibm: [], idx: Date.now().toString() }]);
  };

  const removeCropsIbmHandler = (index: string) => {
    const newCrops = value.filter(i => i.idx !== index);
    setValue(newCrops);
  };

  const updateCropHandler = (index: string, crop: string) => {
    setValue(prev => prev.map(i => i.idx !== index ? i : { ...i, crop }));
  };

  const updateFieldHandler = (
    index: string, name: 'ibm' | 'harvestMonth' | 'states', value: string[],
  ) => {
    setValue(prev => prev.map(i => i.idx !== index ? i : {
      ...i, [name]: value,
    }));
  };

  return (
    <div className={cls.table}>
      <div className={cls.thead}>
        <div className={cls.tr}>
          <div className={cls.th}>Crop name</div>
          <div className={cls.th}>IBM</div>
          <div className={cls.th}>Harvest Month</div>
          <div className={cls.th}>States</div>
        </div>
      </div>
      <div className={cls.tbody}>
        {value.map(cropIbm => (
          <div key={cropIbm.idx} className={cls.tr}>
            <div className={cls.td}>
              <div
                className={cls.cropsTableRemove}
                onClick={() => removeCropsIbmHandler(cropIbm.idx)}>
                <MinusOutlined />
              </div>
              <Select
                className={cls.field}
                onChange={(value) => updateCropHandler(cropIbm.idx, value)}
                options={crops
                  .filter(crop => value
                    .every(item => item.idx === cropIbm.idx || item.crop !== crop.nameMx),
                  ).map(crop => ({ label: crop.nameMx, value: crop.nameMx }))}
                value={cropIbm.crop}
              />
            </div>
            <div className={cls.td}>
              <Select
                className={clsx(cls.field, cls.months)}
                onChange={(value) => updateFieldHandler(cropIbm.idx, 'ibm', value)}
                options={MONTHS.map(ibm => ({ label: ibm, value: ibm }))}
                mode="multiple"
                value={cropIbm.ibm || []}
                maxTagCount={3}
              />
            </div>
            <div className={cls.td}>
              <Select
                className={clsx(cls.field, cls.months)}
                onChange={(value) => updateFieldHandler(cropIbm.idx, 'harvestMonth', value)}
                options={MONTHS.map(ibm => ({ label: ibm, value: ibm }))}
                mode="multiple"
                value={cropIbm.harvestMonth || []}
                maxTagCount={3}
              />
            </div>
            <div className={cls.td}>
              <Select
                className={clsx(cls.field, cls.months)}
                onChange={(value) => updateFieldHandler(cropIbm.idx, 'states', value)}
                options={(states || [])}
                mode="multiple"
                value={cropIbm.states || []}
                maxTagCount={2}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={cls.tfoot}>
        <div className={cls.tr}>
          <div className={cls.td}>
            <div className={cls.cropsTableActions}>
              <Button
                className={cls.cropsTableAdd}
                htmlType="button"
                onClick={addCropsIbmHandler}
                disabled={hasEmptyCrops}
              >+</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
